'use client';

import { useState } from 'react';
import {
	Bars3Icon,
	BellIcon,
	PlusIcon,
	CreditCardIcon,
	BanknotesIcon,
} from '@heroicons/react/24/outline';
import { useLocation } from 'react-router-dom';
import Button from './button';
import { navItems } from '../data/navItems';
import RegisterDebtModal from './RegisterDebtModal';
import CreditCheckModal from './CreditCheckModal';
import NotificationsModal from './NotificationsModal';
import DirectDebitModal from './DirectDebitModal';

const Header = ({ setSidebarOpen }) => {
	const location = useLocation();
	const [showDebtModal, setShowDebtModal] = useState(false);
	const [showCreditCheckModal, setShowCreditCheckModal] = useState(false);
	const [showNotificationsModal, setShowNotificationsModal] = useState(false);
	const [showDirectDebitModal, setShowDirectDebitModal] = useState(false);

	const getPageTitle = (path) => {
		if (path === '/' || path === '/dashboard') {
			return 'Dashboard';
		}

		const matchedNavItem = navItems.find(
			(item) => path === item.to || path.startsWith(item.to),
		);

		if (matchedNavItem) {
			return matchedNavItem.title;
		}

		switch (path) {
			case '/profile':
				return 'Institution Profile';
			case '/notifications':
				return 'Notifications';
			case '/institutions':
				return 'Institutions';
			case '/credit-check':
				return 'Credit Check';
			default:
				return 'Dashboard';
		}
	};

	const pageTitle = getPageTitle(location.pathname);

	return (
		<>
			<header className='bg-white shadow-sm border-b border-gray-200'>
				<div className='flex items-center justify-between h-16 px-4 lg:px-6'>
					<div className='flex items-center'>
						<button
							onClick={() => setSidebarOpen(true)}
							className='lg:hidden p-2 rounded-lg text-gray-400 hover:text-gray-500 hover:bg-gray-100 transition-colors'>
							<Bars3Icon className='h-6 w-6' />
						</button>

						<div className='hidden lg:block'>
							<h2 className='text-gray-900'>{pageTitle}</h2>
						</div>
					</div>

					<div className='flex items-center space-x-3'>
						<button
							onClick={() => setShowNotificationsModal(true)}
							className='p-2 text-gray-400 hover:text-gray-500 hover:bg-gray-100 rounded-lg relative transition-colors'>
							<BellIcon className='h-6 w-6' />
							<span className='absolute top-1 right-1 block h-2 w-2 rounded-full bg-red-500 ring-2 ring-white'></span>
						</button>

						<Button
							type='secondary'
							variant='outlined'
							label='Credit Check'
							iconLeft={<CreditCardIcon className='h-4 w-4' />}
							onClick={() => setShowCreditCheckModal(true)}
							size='M'
						/>

						<Button
							type='primary'
							label='Register Debt'
							iconLeft={<PlusIcon className='h-4 w-4' />}
							onClick={() => setShowDebtModal(true)}
							size='M'
						/>

						<Button
							type='primary'
							label='Direct Debit'
							iconLeft={<BanknotesIcon className='h-4 w-4' />}
							onClick={() => setShowDirectDebitModal(true)}
							size='M'
						/>
					</div>
				</div>
			</header>

			{/* Modals */}
			{showDebtModal && (
				<RegisterDebtModal closeModal={() => setShowDebtModal(false)} />
			)}

			{showCreditCheckModal && (
				<CreditCheckModal
					closeModal={() => setShowCreditCheckModal(false)}
				/>
			)}

			{showDirectDebitModal && (
				<DirectDebitModal
					closeModal={() => setShowDirectDebitModal(false)}
				/>
			)}

			{showNotificationsModal && (
				<NotificationsModal
					closeModal={() => setShowNotificationsModal(false)}
				/>
			)}
		</>
	);
};

export default Header;
